export default __webpack_public_path__ + "static/media/machine.7eb5db12.jpg";